import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";
import Location from "../../Search/Location";
import { Input, LiveSearch, Select } from "../../Form";
import { ButtonBrand, ButtonPrimary, ButtonTertiary } from "../../Button";
import { Field, initialize, reduxForm, getFormValues } from "redux-form";
import { generalInteraction } from "../../../modules/analytics";
import { fetchAgencies, storeLastSimpleSearch } from "../../../redux/actions";
import { LiveSearchSimple } from "../../Form/LiveSearch/LiveSearchSimple";
import * as ROUTES from "../../../Router/corporate_routes";
import * as VENUE_ROUTES from "../../../Router/venue_routes";
import * as ADMIN_ROUTES from "../../../Router/admin_routes";
import { DEFAULT_SEARCH_RADIUS_IN_METRES } from "../../../constants";
import MultiSelect from "../../../ui/MultiSelect";
import { isAgency, isLoggedIn, isRolePlatformAdmin, token } from "../../../modules/auth";
import { checkVenueForPreferredProgramme } from "../../../services/hotelGroupService/preferredProgrammesService";
import queryString from "query-string";
import { omit } from "lodash";

const form = "simple-search-start";

function AgencySearchBanner({
  agencies = [],
  capacity,
  initialize,
  handleSubmit,
  generalInteraction,
  storeLastSimpleSearch,
  destroy,
  history,
  isRolePlatformAdmin,
  isSuperAgencyAndHasMultipleAgencies,
  isLoggedIn,
  isAgency,
  token,
  fetchAgencies
}) {
  const [company, setCompany] = useState();
  const [location, setLocation] = useState(null);
  const [name] = useState(null);
  const [error, setError] = useState(null);
  const blankVenueInfo = { id: false, link: false };
  const [searchFields, setSearchFields] = useState("");
  const [isGroup, setIsGroup] = useState(false);
  const [groupName, setGroupName] = useState(false);
  const [venueInfo, setVenueInfo] = useState(blankVenueInfo);
  const [selectedAgency, setSelectedAgency] = useState(false)
  const [selectedCompany, setSelectedCompany] = useState(false)
  const [searchAgencies, setAgencies] = useState([])
  const [companies, setCompanies] = useState([])

  useEffect(() => {
    if (isAgency || isRolePlatformAdmin) {
      fetchAgencies(token, 1, { visibleOnly: true }, true).then(response => {
        setAgencies(response.data.data);
        if(response.data.data.length === 1){
          let agency = response.data.data.find(x=>x!==undefined)
          setCompanies(agency.companies)
        }
      });
    }
  }, []);

  useEffect(() => {
    if (company?.id) {
      history.push(ROUTES.FRONTEND.COMPANY.VIEW.replace(":id", company.id));
    }
  }, [company, history]);

  const submit = () => {
    if (location) {
      const locationParams = location ? location : {};
      initialize(
        "simple-search",
        {
          ...locationParams,
          sortBy: "ContentUpdate",
          capacity,
          name,
        },
        {
          updateUnregisteredFields: true,
        }
      );
      history.push(`/search?${queryString.stringify(
        omit( {
          ...locationParams,
          sortBy: selectedCompany && selectedCompany.isCorporate? "Company Preferred Programme" : (selectedAgency || (selectedCompany && !selectedCompany.isCorporate) ? "Agency Preferred Programme" : "ContentUpdate"),
          capacity,
          name,
        }, ["placeArea"])
      )}`);
      reset();
    } else {
      setError(true);
    }
  };

  useEffect(() => {
    if (location !== null) {
      generalInteraction({
        type: "general_home_location_click",
        data: location && location.location,
      });
    }
  }, [location]);

  useEffect(() => {
    setError(false);
  }, [location]);

  const primaryActionClicked = e => {
    if (searchFields === "venue") {
      generalInteraction({
        type: "corporate_home_venue_info_click",
        data: location && location.location,
      });
      history.push(venueInfo.link);
      if (e) {
        e.preventDefault();
      }
    } else {
      generalInteraction({
        type: "corporate_home_quick_search_click",
        data: location && location.location,
      });
    }
  };

  const secondaryActionClicked = () => {
    if (searchFields === "venue") {
      history.push("/request-for-proposal?venues=" + venueInfo.id);
    } else {

      const link =
        "/advanced-search?results=13326&back_projection=0&exhibition=0&" +
        (location && location.location
          ? "location=" + location.location + "&"
          : "") +
        (location && location.lat ? "lat=" + location.lat + "&" : "") +
        (location && location.lng ? "lng=" + location.lng + "&" : "") +
        (selectedAgency ? 'agency=' + selectedAgency + '&' : '') +
        (selectedCompany ? 'company=' + selectedCompany.value + '&' : '') +
        'sortBy=' + (selectedCompany && selectedCompany.isCorporate? "Company Preferred Programme" : (selectedAgency || (selectedCompany && !selectedCompany.isCorporate) ? "Agency Preferred Programme" : "ContentUpdate"))  + '&' +

        "location_type=Map&radius=" +
        DEFAULT_SEARCH_RADIUS_IN_METRES +
        (capacity ? "&capacity=" + capacity : "") +
        `&types=1&types=2&types=3&types=4&types=5&types=6&types=7&types=8&types=9&types=10&types=11&types=12&types=13`;

      history.push(link);
    }
  };

  const reset = () => {
    destroy(form);
    setLocation(null);
  };

  const primaryActionText =
    searchFields === "venue" ? "Venue Info" : "Quick Search";
  const secondaryActionText =
    searchFields === "venue" ? "Enquire Now" : "Advanced Search";

  const getAgencyOptions = () => {
    if(searchAgencies) {
      return searchAgencies.map(function (agency) {
        return {
          text: agency.name,
          value: agency.id,
          label: agency.name,
        }
      })
    }else {
      return []
    }
  }

  const agencyOnChange = (e) => {
    let agency = searchAgencies.find(function (agency) {
      return parseInt(agency.id) === parseInt(e.value)
    })
    setSelectedAgency(e.value)
    setCompanies(agency.companies)
    setSelectedCompany(null)
  }

  const getCompanyOptions = () => {
    if(companies) {

      return companies.map(function (company) {
        return {
          text: company.name,
          value: company.id,
          label: company.name,
          isCorporate: company.isCorporate
        }
      })
    }else {
      return []
    }
  }

  const companyOnChange = (e) => {
    setSelectedCompany(e)
  }

  return (
    <>
      {/*<div className={"flex py-2"}>*/}
      {/*  <div className="flex w-full justify-between gap-2 bg-light-grey p-2">*/}
      {/*    /!*<Link to="/request-for-proposal" className={"text-white w-1/2"}>*!/*/}
      {/*    /!*  <ButtonBrand classes={"w-full"}>Start a New RFP</ButtonBrand>*!/*/}
      {/*    /!*</Link>*!/*/}
      {/*    /!*<div className="w-1/2">*!/*/}
      {/*    /!*  <LiveSearchSimple*!/*/}
      {/*    /!*    key={company?.id || "empty"}*!/*/}
      {/*    /!*    id="companySearch"*!/*/}
      {/*    /!*    classes="mb-0"*!/*/}
      {/*    /!*    fieldClassName={"h-[40px]"}*!/*/}
      {/*    /!*    label={""}*!/*/}
      {/*    /!*    auth*!/*/}
      {/*    /!*    placeholder={"View a company"}*!/*/}
      {/*    /!*    initQuery={company?.name}*!/*/}
      {/*    /!*    getText={result => result.name}*!/*/}
      {/*    /!*    url={*!/*/}
      {/*    /!*      window.API +*!/*/}
      {/*    /!*      ROUTES.API.COMPANIES.SEARCH +*!/*/}
      {/*    /!*      "?agencyIds=" +*!/*/}
      {/*    /!*      agencies.map(a => a.id).join(",")*!/*/}
      {/*    /!*    }*!/*/}
      {/*    /!*    onChange={selectedCompany => {*!/*/}
      {/*    /!*      setCompany(selectedCompany);*!/*/}
      {/*    /!*    }}*!/*/}
      {/*    /!*  />*!/*/}
      {/*    /!*</div>*!/*/}
      {/*  </div>*/}
      {/*</div>*/}

      <form
        className="edge-home-hero-search-form mt-4"
        onSubmit={handleSubmit(submit)}
        autoComplete="off"
      >

        <div className="flex flex-col xl:flex-row bg-light-grey p-2">
            {isSuperAgencyAndHasMultipleAgencies || isRolePlatformAdmin ?
            <div className="col-w-1/2 pr-2 ">
              <p className="uppercase font-normal mb-1 text-xs">
                Which Agency?
              </p>
              <MultiSelect
                id="agency-search"
                options={getAgencyOptions()}
                name="agency"
                labelClassName="sr-only"
                wrapperClassName="mb-2 xl:mb-0 xl:mr-2"
                component={Select}
                onChange={ e => agencyOnChange(e)}
                placeholder="Select Agency"
              />
            </div> : null }

            {selectedAgency || (isLoggedIn && !isSuperAgencyAndHasMultipleAgencies && !isRolePlatformAdmin) ?
              <div  className="col-w-1/2">
                <p className="uppercase font-normal mb-1 text-xs">
                  Search For Company
                </p>
                <MultiSelect
                  id="company-search"
                  options={getCompanyOptions()}
                  name="company"
                  labelClassName="sr-only"
                  wrapperClassName="mb-2 xl:mb-0 xl:mr-2"
                  component={Select}
                  onChange={ e => companyOnChange(e)}
                  placeholder="Select Company"
                  value={selectedCompany}
                />
              </div> : null
            }
        </div>
        <div className="flex flex-wrap flex-col xl:flex-row bg-light-grey p-2">
          <div className="flex-1">
            <Location
              formId={form}
              id="location-search"
              icon="/img/map-marker.svg"
              label="Location"
              labelClassName="sr-only"
              name="location"
              placeholder="Location"
              wrapperClassName="mb-2 xl:mb-0 xl:mr-2"
              noBottom
              white
              tall
              onPlaceFound={(lat, lng, name, { placeArea }, addressType) => {
                if (name !== "") {
                  setSearchFields("location");
                } else if (searchFields === "location") {
                  setSearchFields("");
                }
                setLocation({
                  location: name,
                  lat: lat,
                  lng: lng,
                  placeArea: placeArea,
                  addressType,
                  group: isGroup ? isGroup : null,
                  groupName: groupName ? groupName : null,
                  agency: selectedAgency,
                  company: selectedCompany.value
                });
                storeLastSimpleSearch(null);
              }}
              disabled={searchFields === "venue"}
              onPlaceChange={locationFieldValue => {
                // console.log('Place changed');
                if (locationFieldValue !== "") {
                  setSearchFields("location");
                } else if (searchFields === "location") {
                  setSearchFields("");
                }
              }}
            />
          </div>

          <div className="flex-1">
            <LiveSearch
              disabled={searchFields === "location" && !isGroup}
              id="venue-search"
              formId={form}
              url={`${window.API}${VENUE_ROUTES.API.QUICK_SEARCH}`}
              onSelect={result => {
                if(result.group) {
                  setLocation({
                    group: result.id,
                    groupName: result.name
                  });
                  setSearchFields("group");
                  setIsGroup(result.id)
                  setGroupName(result.name)
                }else {
                  setVenueInfo({
                    id: result.id,
                    link: "/venue/" + result.slug ,
                  });
                  setSearchFields("venue");
                  setIsGroup(false)
                  setGroupName(false)
                }
              }}
              onClear={() => {
                setVenueInfo(blankVenueInfo);
                setSearchFields("");
                setIsGroup(false)
                setGroupName(false)
              }}
              label="Venue name or brand"
              labelClassName="sr-only"
              name="venue"
              placeholder="Venue name or brand"
              fieldClassName="w-full"
              wrapperClassName="mb-2 xl:mb-0 xl:mr-2"
              noBottom
              white
              tall
              getText={item => item.display_name}
            />
          </div>

          <div className="flex-1">
            <Field
              name="capacity"
              placeholder="No. of Attendees"
              white
              tall
              noBottom
              className=""
              wrapperClassName="xl:mb-0 xl:mr-0"
              labelClassName="mb-0"
              component={Input}
            />
          </div>
        </div>

        <div className="flex my-4 justify-between gap-2 w-full">
          <ButtonPrimary
            big
            submit
            style={{ width: "inherit" }}
            classes="w-1/2 font-bold"
            onClick={() => {
              primaryActionClicked();
            }}
          >
            {primaryActionText}
          </ButtonPrimary>

          <ButtonBrand
            big
            classes="w-1/2 font-bold"
            style={{ width: "inherit" }}
            onClick={() => {
              secondaryActionClicked();
            }}
          >
            {secondaryActionText}
          </ButtonBrand>
        </div>

        {error && (
          <div className="xl:flex">
            <div className="col-w-full justify-center md:justify-start xl:col-w-3/5 flex pt-4">
              <p className="text-white bg-dark-red p-1 mt-2 font-bold">
                Please choose a location or Venue
              </p>
            </div>
          </div>
        )}
      </form>

      <div className="flex text-center w-full">
        <span className={"font-bold mb-2 text-center w-full"}>OR</span>
      </div>

      <div className="flex my-4 justify-between w-full gap-2 text-white">
        <Link to={VENUE_ROUTES.FRONTEND.UK_VENUE_LOCATIONS} className={"w-1/2"}>
          <ButtonPrimary
            classes="w-full mb-2"
            style={{ backgroundColor: "#CB414B" }}
          >
            UK Locations
          </ButtonPrimary>
        </Link>

        <Link
          to={VENUE_ROUTES.FRONTEND.WORLDWIDE_VENUE_LOCATIONS}
          className={"w-1/2"}
        >
          <ButtonPrimary
            classes="w-full mb-2"
            style={{ backgroundColor: "#4BC7FE" }}
          >
            Worldwide Locations
          </ButtonPrimary>
        </Link>
      </div>

      <hr className={"border border-grey w-full my-4"} />

      <div className="flex flex-wrap w-full">
        <div className="w-full sm:w-1/2 pr-0 sm:pr-2 mb-4 sm:mb-0">
          <ButtonTertiary classes="w-full mb-2">
            <Link
              to={ADMIN_ROUTES.FRONTEND.SAVED_SEARCHES}
              className="text-white"
            >
              Saved searches
            </Link>
          </ButtonTertiary>

          <ButtonTertiary classes="w-full">
            <Link to={ADMIN_ROUTES.FRONTEND.SHORTLISTS} className="text-white">
              View shortlists
            </Link>
          </ButtonTertiary>
        </div>

        <div className="w-full sm:w-1/2 pl-0 sm:pl-2">
          <ButtonTertiary classes="w-full mb-2">
            <Link to={ADMIN_ROUTES.FRONTEND.MY_RFPS} className="text-white">
              My RFPs
            </Link>
          </ButtonTertiary>

          <ButtonTertiary classes="w-full">
            <Link to={ADMIN_ROUTES.FRONTEND.TEMPLATES} className="text-white">
              Use previous template
            </Link>
          </ButtonTertiary>
        </div>
      </div>
    </>
  );
}

const mapDispatchToProps = {
  initialize,
  generalInteraction,
  storeLastSimpleSearch,
  fetchAgencies
};

const mapStateToProps  = state => {
  const v = getFormValues(form)(state) || {};
  return {
    isSuperAgencyAndHasMultipleAgencies: state.auth.agency && state.auth?.agency?.is_super_agent  &&  state.auth.agency.child_agencies &&  state.auth.agency.child_agencies.length  > 0,
    isRolePlatformAdmin: isRolePlatformAdmin(state),
    isLoggedIn: isLoggedIn(state),
    isAgency: isAgency(state),
    token: token(state),
    capacity: v.capacity
  }
}

export default withRouter(
  reduxForm({ form })(connect(mapStateToProps, mapDispatchToProps)(AgencySearchBanner))
);
